const heroArchiveLocationBlock = document.querySelector(
	'.block-hero-archive-locations'
);

if (heroArchiveLocationBlock) {
	const stateSelect = heroArchiveLocationBlock.querySelector(
		'.block-hero-archive-locations__state-select'
	);
	const stateSelected = heroArchiveLocationBlock.querySelector(
		'.block-hero-archive-locations__state-select-selected'
	);
	const stateOptions = heroArchiveLocationBlock.querySelectorAll(
		'.block-hero-archive-locations__state-select-option'
	);
	const locations = heroArchiveLocationBlock.querySelectorAll(
		'.block-hero-archive-locations__location'
	);

	const closeStateSelectDropdown = () => {
		stateSelect.classList.remove('active');
		document.removeEventListener('click', closeStateSelectDropdown);
	};

	stateSelected?.addEventListener('click', () => {
		stateSelect.classList.toggle('active');

		if (stateSelect.classList.contains('active')) {
			document.addEventListener('click', closeStateSelectDropdown, {
				capture: true,
			});
		}
	});

	document.addEventListener('keydown', (e) => {
		if ('Escape' === e.key) {
			closeStateSelectDropdown();
		}
	});

	stateOptions?.forEach((option) => {
		option.addEventListener('click', (e) => {
			locations?.forEach((location) => {
				const state = e.target.getAttribute('data-state');
				if ('' === state) {
					location.classList.remove('hidden');
					location.removeAttribute('hidden');
					stateSelected.innerText = 'All States';
				} else {
					location.classList.toggle(
						'hidden',
						state !== location.getAttribute('data-state')
					);
					location.toggleAttribute(
						'hidden',
						state !== location.getAttribute('data-state')
					);

					stateSelected.innerText =
						e.target.getAttribute('data-state-name');
				}
			});
		});
	});

	locations?.forEach((location) => {
		location.addEventListener('click', (e) => {
			const locationButton = e.target.closest(
				'.block-hero-archive-locations__location'
			);
			const { id } = locationButton?.dataset;

			if (id) {
				const expirationDate = new Date();
				expirationDate.setDate(expirationDate.getDate() + 30);
				document.cookie = `wpe-us=${id}; expires=${expirationDate.toUTCString()}; path=/`;
			}
		});
	});
}
